<template>
  <section id="hearts">
    <Heart
      v-for="(h,i) in hearts"
      :heart="h"
      :key="i"
      :artist="h.artist"
      :hash="h.image.private_hash"
      :rank="h.rank"
    />

    <div id="zoom-template">
      <div >
        <header>My image zoom template</header>
        <div id="zoom-container"></div>
        <aside>Comment on my image</aside>
      </div>
    </div>

  </section>
</template>

<script>
import Heart from "@/components/Heart.vue";
import mediumZoom from "medium-zoom";

export default {
  name: "Hearts",
  props:[
      "hearts"
  ],
  components: {
    Heart,
  },
  data() {
    return {
    //   hearts: [],
    };
  },
  mounted() {
    console.log(this.hearts);
  },
  updated() {
    mediumZoom("#hearts img", {
      margin: 24,
      background: "#ffd4ce",
      scrollOffset: 0
    //   template: '#zoom-template'
    });
  },
};
</script>

<style scoped></style>